import React from 'react';
import PropTypes from 'prop-types';
import constants from '../../qti/Constants';
import styles from './additionalResourcesBar.scss';
import { t } from '../../services/i18nService';
import chromeAppService from '../../services/ChromeAppService';

class ChromeAppAdditionalResource extends React.PureComponent {
    static propTypes = {
        resource: PropTypes.object.isRequired,
    };

    callShowChromeAdditionalResourcesIframe = () => {
        const { resource } = this.props;
        chromeAppService.dispatchShowChromeAppAdditionalResourceIframe(resource);
    }

    onButtonClick = (e) => {
        e.preventDefault();
        this.callShowChromeAdditionalResourcesIframe();
    };

    render() {
        const { resource } = this.props;
        let icon;
        let rel;

        switch (resource.type) {
        case constants.additionalResourceType.FILE:
            icon = 'fa-file';
            rel = 'opener';
            break;

        default:
            icon = 'fa-globe';
            rel = 'noopener noreferrer';
            break;
        }

        return (
            <li>
                <button
                    role="link"
                    onClick={this.onButtonClick}
                    className={`${styles.resourceButton} ${styles.chromeAppButton}`}
                    rel={rel}
                    aria-label={`${resource.title} (${t('general.opensInNewWindow')})`}
                >
                    <i className={`fa ${icon}`} aria-hidden="true" />
                    { resource.title }

                    <i className={`fa fa-external-link ${styles.external}`} aria-hidden="true" />
                </button>
            </li>
        );
    }
}

export default ChromeAppAdditionalResource;
